/**
 * Close behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};


  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.close.attach}}
   */
  Drupal.behaviors.close = {
    attach: function (context, settings) {

      $('[data-dismiss]').once('close').on('click touchstart', function (e) {
          var target =  $('[data-dismiss]').attr('data-dismiss');
          $(target).fadeOut(100);
      });
    }

  }

})(Drupal, jQuery);
